import React, { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import styled from 'styled-components';
import CreatAgentModal from '../components/CreatAgentModal';
import OverlayModal from '../components/ui/OverlayModal';
import AgentSuccessModal from '../components/AgentSuccessModal';
import PageHeader from '../components/ui/PageHeader';
import { BackLink } from '../components/ui/ui.styles';
import { useContextHook } from 'use-context-hook';
import { AuthContext } from '../Context/authContext';

const BuilderShell = styled.div`
  width: 100%;
  max-width: 72rem;
  margin: 0 auto;
`;

const CreateAgentPage = ({ agentId: agentIdProp, isDuplicate = false }) => {
  const { id: routeId } = useParams();
  const agentId = agentIdProp || routeId;
  const isEdit = !!agentId && !isDuplicate;
  const navigate = useNavigate();
  const [successModal, setSuccessModal] = useState(false);
  const { refetch } = useContextHook(AuthContext, v => ({
    refetch: v.refetch,
  }));

  const title = isDuplicate ? 'Duplicate Agent' : isEdit ? 'Edit Your Agent' : 'Build Your Agent';
  const subtitle = isDuplicate
    ? 'Create a copy of this agent with the same instructions and tools.'
    : isEdit
      ? 'Update your agent instructions, model, tools, skills, and memory settings.'
      : 'Name your agent, define its core instructions, configure behavior, and attach tools & skills.';

  return (
    <BuilderShell>
      {successModal && (
        <OverlayModal title="Agent Created!" onClose={() => navigate('/agents')} placement="center" width={420}>
          <AgentSuccessModal />
        </OverlayModal>
      )}
      <BackLink type="button" onClick={() => navigate('/agents')}>
        <ArrowLeft size={16} /> Back to Agents
      </BackLink>
      <PageHeader title={title} subtitle={subtitle} />
      <CreatAgentModal
        isEdit={agentId ? { id: agentId } : undefined}
        isDuplicate={isDuplicate}
        setSuccessModal={setSuccessModal}
        refetch={refetch}
        onClose={() => navigate('/agents')}
      />
    </BuilderShell>
  );
};

export default CreateAgentPage;
